import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {Router} from '@angular/router';
import {ModalService} from '../../../shared/modals/modal/modal.service';
import {UserService} from '../../../services/user/user.service';
import {NgForm} from '@angular/forms';
import {ErrorModel} from '../../../models/shared/error.model';
import {TranslateService} from '@ngx-translate/core';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css']
})
export class ForgotPassComponent implements OnInit {

  submitted = false;

  constructor(private authSv: AuthService,
              private userSv: UserService,
              private router: Router,
              private modalSv: ModalService,
              private tSv: TranslateService) { }

  ngOnInit() {
  }

  onForgotPassClicked(form: NgForm) {

    let email = form.value.email;
    if (email) {
      email = email.toLowerCase();
    }

    this.userSv.forgotPasswordEmail(email).subscribe(() => {
      this.submitted = true;
    }, (error: ErrorModel) => {
      this.modalSv.showErrorModal(this.tSv.instant('reusable.error'),
        this.tSv.instant('reusable.unknownError'));
    });
  }

  onSignInClicked() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['signin']));
  }

  onSignupClicked() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['signup']));
  }

  onLogoClicked() {
    this.router.navigate(NavigationModel.getHomeURLPaths([]));
  }

}
